import { Grid } from "@mui/material";
import ShowSubMenuInfo from "../InfoSubMenu/ShowSubMenuInfo/ShowSubMenuInfo";

export default function DescrizioneStatusSubMenu({ stato, prenotazioni, isSalaRiunione }) {

  return (
    <>
      <Grid container>
        <ShowSubMenuInfo stato={stato} info={{ prenotazioni, isSalaRiunione }} />
      </Grid>
    </>
  );
}
